// extracted by mini-css-extract-plugin
export var avatar = "_qz-3";
export var avatarContainer = "_qz-2";
export var avatarSpacer = "_qz-5";
export var avatarSpacerContainer = "_qz-4";
export var avatarStackContainer = "_qz-1";
export var bubble = "_qz-0";
export var remainderBubble = "_qz-6";